import axios from 'axios';

const search = filters => axios.get('loadboard', { params: filters });

export default {
  search,
};



// WEBPACK FOOTER //
// ./src/api/loadboard.js